import { FaGithub } from 'react-icons/fa6';
import { FaLinkedin } from 'react-icons/fa';

export const socialLinks = [

  // ========================
  // SOCIAL LINKS DATA
  // ========================
  {
    href: "https://github.com/KABUYA-SINA",
    label: "GitHub profile",
    icon: <FaGithub aria-hidden="true" />,
  },

  {
    href: "https://linkedin.com/in/sina-sabrin",
    label: "LinkedIn profile",
    icon: <FaLinkedin aria-hidden="true" />,
  },
];